import * as React from "react";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { Link } from "@/components/common/Link";
import { Mail, Phone } from "lucide-react";
export default function GetInTouchWithAlignPhysiotherapy() {
  return <section className="bg-background py-16 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center">
          <div className="relative h-[400px] lg:h-[500px] rounded-xl overflow-hidden shadow-medium">
            <img src="https://immune-minnow.10web.cloud/wp-content/uploads/2026/01/Align-Logo.png" alt="Consultation room" className="w-full h-full object-cover" />
          </div>

          <Card className="shadow-medium border border-border">
            <CardHeader>
              <CardTitle className="text-3xl md:text-4xl font-display font-bold text-foreground">
                Get in Touch with Align Physiotherapy
              </CardTitle>
              <CardDescription className="text-muted-foreground text-base mt-3 leading-relaxed">
                Whether you have questions about our services or would like to schedule an appointment, we're here to help. Our experienced team at Align Physiotherapy is ready to support your journey to better movement and recovery.
              </CardDescription>
            </CardHeader>
            <CardContent className="space-y-6">
              <div className="space-y-4">
                <div className="flex items-center gap-3" data-index={0}>
                  <div className="flex items-center justify-center size-10 rounded-lg bg-primary/10 text-primary shrink-0">
                    <Phone className="size-5" />
                  </div>
                  <div>
                    <p className="text-sm text-muted-foreground">Call us</p>
                    <Link to="tel:+447463682889" className="text-foreground font-medium hover:text-primary transition-colors">
                      07463682889
                    </Link>
                  </div>
                </div>
                <div className="flex items-center gap-3" data-index={1}>
                  <div className="flex items-center justify-center size-10 rounded-lg bg-primary/10 text-primary shrink-0">
                    <Mail className="size-5" />
                  </div>
                  <div>
                    <p className="text-sm text-muted-foreground">Email us</p>
                    <Link to="mailto:appointments@alignphysiotherapy.co.uk" className="text-foreground font-medium hover:text-primary transition-colors">
                      appointments@alignphysiotherapy.co.uk
                    </Link>
                  </div>
                </div>
              </div>

              <div className="pt-4">
                <Link to="https://align-physiotherapy.uk3.cliniko.com/bookings?business_id=1869864670421067946&practitioner_id=1869864668449745369&appointment_type_id=1869864670219741836">
                  <Button size="lg" className="w-full sm:w-auto">
                    Book an Appointment
                  </Button>
                </Link>
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
    </section>;
}